import useAccessTokenAndShopId from '../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { useListInspectionsQuery } from '../../redux/api/inspectionApi'
import { DviListProvider } from './DviListProvider'

export const DviListProviderWrapper = ({
  children
}: {
  children: React.ReactNode
}) => {
  const { userId, accessToken, shopId } = useAccessTokenAndShopId()
  // include inspections that is assigned to the user and not finished yet
  const { data: inspectionsRaw, isLoading: loadingInspections } =
    useListInspectionsQuery(
      {
        authorization: accessToken,
        template: false,
        numResults: 150,
        endDateExclusive: '9999-12-31T23:59:59.000Z',
        shop: shopId,
        technicians: [userId],
        isFinished: false
      },
      { pollingInterval: 60000, refetchOnMountOrArgChange: true }
    )
  return (
    <DviListProvider {...{ inspectionsRaw, loadingInspections }}>
      {children}
    </DviListProvider>
  )
}
